import { ThemeEvents, VariantSelectedEvent, VariantUpdateEvent } from '@theme/events';

const initStickyAtc = () => {
  const bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  if (bar.dataset.stickyAtcBound === 'true') return;
  bar.dataset.stickyAtcBound = 'true';

  const showOffset = 1300; // show a bit earlier while scrolling

  const section = bar.closest('.shopify-section');
  const productInformation = document.querySelector('.product-information');
  if (!section || !productInformation) return;

  const productId = bar.dataset.productId;

  let sentinel = document.querySelector('.sticky-atc__sentinel');
  if (!sentinel) {
    sentinel = document.createElement('div');
    sentinel.className = 'sticky-atc__sentinel';
    productInformation.insertAdjacentElement('afterend', sentinel);
  }

  let triggerY = sentinel.getBoundingClientRect().top + window.scrollY;

  const updateTrigger = () => {
    triggerY = sentinel.getBoundingClientRect().top + window.scrollY;
    toggle();
  };

  let footerVisible = false;

  const footer = document.querySelector('footer, .footer, [data-footer]');
  if (footer) {
    const footerObserver = new IntersectionObserver(
      ([entry]) => {
        footerVisible = entry.isIntersecting;
        toggle();
      },
      { threshold: 0 }
    );
    footerObserver.observe(footer);
  }

  const toggle = () => {
    const shouldShow = window.scrollY + showOffset > triggerY && !footerVisible;
    bar.classList.toggle('is-visible', shouldShow);
  };

  const onScroll = () => {
    window.requestAnimationFrame(toggle);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateTrigger);
  toggle();

  const forwardVariantUpdate = (event) => {
    if (!event.detail?.data?.productId || event.detail.data.productId.toString() !== productId) return;
    const forwarded = new VariantUpdateEvent(event.detail.resource, event.detail.sourceId, event.detail.data);
    section.dispatchEvent(forwarded);
  };

  const forwardVariantSelected = (event) => {
    if (!event.detail?.resource) return;
    const forwarded = new VariantSelectedEvent(event.detail.resource);
    section.dispatchEvent(forwarded);
  };

  document.addEventListener(ThemeEvents.variantUpdate, forwardVariantUpdate);
  document.addEventListener(ThemeEvents.variantSelected, forwardVariantSelected);

  const quantityInput = bar.querySelector('quantity-selector-component input[ref="quantityInput"]');
  if (quantityInput) {
    quantityInput.addEventListener('input', () => {
      const value = Number.parseInt(quantityInput.value, 10);
      if (!value || value < 1) {
        quantityInput.value = '1';
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', initStickyAtc);
document.addEventListener('shopify:section:load', initStickyAtc);
